import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Standard shadcn `cn()` helper. Combines clsx (conditional class composition)
 * with tailwind-merge (deduplicates conflicting Tailwind classes — last wins).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
